// eslint-disable-next-line import/prefer-default-export
export const AnalyticEventTypes = {
  AssignABook: 22,
  DownloadMonthlyReport: 41,
  LoadGeneralReport: 42,
  GoToSideBarSection: 57,
  GoToBookDetail: 58,
  GoToQuickStats: 59,
}
